var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"node",class:_vm.themeMap[_vm.form.type]},[_c('img',{attrs:{"src":_vm.image.logo}}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.form.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }